import { render } from "./SelectorUbicacionAlmacen.vue?vue&type=template&id=b74c8844&scoped=true"
import script from "./SelectorUbicacionAlmacen.vue?vue&type=script&lang=js"
export * from "./SelectorUbicacionAlmacen.vue?vue&type=script&lang=js"

import "./SelectorUbicacionAlmacen.vue?vue&type=style&index=0&id=b74c8844&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b74c8844"]])

export default __exports__